module.exports = __webpack_public_path__ + "img/背景.a584b252.jpg";